'use es6';

import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { secureDocument } from 'sanitize-text/sanitizers/SanitizeConfiguration';

const SANITIZE_CONFIG = {
  dom: secureDocument,
  attributes: {
    a: ['href', 'title', 'target'],
    blockquote: ['cite'],
    ol: ['start', 'type'],
    q: ['cite'],
    ul: ['type'],
  },
  elements: [
    'a',
    'b',
    'blockquote',
    'br',
    'caption',
    'cite',
    'code',
    'dd',
    'dl',
    'dt',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'i',
    'li',
    'ol',
    'p',
    'pre',
    'q',
    'small',
    'strike',
    'strong',
    'sub',
    'sup',
    'u',
    'ul',
    'font',
    'div',
    'span',
  ],
  protocols: {
    a: { href: ['ftp', 'http', 'https', 'mailto'] },
    blockquote: { cite: ['http', 'https'] },
    q: { cite: ['http', 'https'] },
  },
  remove_contents: ['style', 'script'],
};

export const sanitizeHtmlText = (text) => sanitize(text || '', SANITIZE_CONFIG);

export const makeSafeInnerHTML = (string) => {
  return { __html: sanitizeHtmlText(string || '') };
};

export const decodeHtmlEntities = (string) => {
  const textareaElement = document.createElement('textarea');
  textareaElement.innerHTML = string;
  return textareaElement.value;
};

export const encodeHtmlEntities = (string) =>
  string &&
  string.replace(/[\u00A0-\u9999<>&]/gim, (i) => `&#${i.charCodeAt(0)};`);
